module.exports = __webpack_public_path__ + "static/media/图片5.b4aabc30.png";